import { render } from "./RqDetail.vue?vue&type=template&id=948ab21a&scoped=true"
import script from "./RqDetail.vue?vue&type=script&lang=js"
export * from "./RqDetail.vue?vue&type=script&lang=js"

import "./RqDetail.vue?vue&type=style&index=0&id=948ab21a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-948ab21a"]])

export default __exports__